import React from 'react'
import {
  FormLabel,
  FormControl,
  Input,
  FormErrorMessage
} from '@chakra-ui/react'

interface FormInputProps {
  id?: string
  label?: string
  info?: string | JSX.Element
  error?: string
  maxLength?: number
  [htmlAttribute: string]: any
}

export const FormInput: React.FunctionComponent<FormInputProps> = ({
  id,
  label,
  error,
  info,
  field,
  isInvalid,
  maxLength,
  ...rest
}) => {
  delete rest.form // this is used to fix a formik bug where Enter wont submit
  return (
    <FormControl isInvalid={isInvalid}>
      <FormLabel fontWeight="bold" fontSize="sm" htmlFor={id} mb={1}>
        {label}
      </FormLabel>
      <Input
        variant="flushed"
        bg="#FAFAFA"
        fontSize="md"
        borderBottomColor="#757575"
        id={id}
        maxLength={maxLength}
        {...field}
        {...rest}
        _invalid={{ border: '2px solid', borderColor: '#E1202A' }}
      />
      {error !== undefined && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  )
}
